export enum AspectCode {
  Accounting = "acc",
  AIBookkeeper = "aib",
  AdvancedLedger = "adv",
  AskDigits = "ask",
  AskDigitsAgent = "agi",
  Audit = "adt",
  AutomatedBankRecs = "abr",
  AutomatedReceiptHandling = "arh",
  BankRecChecklist = "brc",
  BanksAndCards = "bnc",
  Branding = "bnd",
  CategoryManager = "cmg",
  ClosedPeriod = "clp",
  Connections = "cnx",
  CustomerDirectory = "cdr",
  DimensionManager = "dmg",
  Employments = "emp",
  Financials = "fin",
  FirmLevelPredictions = "flp",
  FutureDatedTransactions = "fdt",
  Collect = "gpd", // Formerly Get Paid
  Home = "hom",
  InvoiceCreditCards = "icc",
  InvoiceManualBankAccount = "imb",
  Invoicing = "inv",
  MultiCustomDashboards = "mcd",
  PayBills = "pbl",
  QuarterlyDashboard = "qtr",
  Reports = "rpt",
  RestrictLedgerEdits = "rle",
  Schedules = "sch",
  Sharing = "shr",
  TransactionActionItems = "tai",
  Upsells = "ups",
  Vault = "vlt",
  VendorDirectory = "vdr",
}
